const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedPlayerCommissionLevel: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const playercommissionlevel = (state = initialState, action) => {
	switch (action.type) {
		case 'PLAYERCOMMISSIONLEVEL_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'PLAYERCOMMISSIONLEVEL_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'PLAYERCOMMISSIONLEVEL_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'PLAYERCOMMISSIONLEVEL_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'PLAYERCOMMISSIONLEVEL_GET_CURRENT':
			return {
				...state,
				selectedPlayerCommissionLevel: action.selectedPlayerCommissionLevel,
			}
		case 'PLAYERCOMMISSIONLEVEL_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default playercommissionlevel
